import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Button } from "@component/button";
import { StarIcon } from "lucide-react";

interface Props {
    isOpen: boolean;
    title: string
    onClose: () => void;
    onConfirm: () => void;
}

export default function AIInternshipDialog(props: Props) {
    return (
        <Dialog open={props.isOpen} onOpenChange={(open) => !open && props.onClose()}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <div className="flex items-center gap-2 mb-2">
                        <StarIcon className="h-5 w-5 text-blue-500 fill-blue-500" />
                        <DialogTitle>{props.title}</DialogTitle>
                    </div>
                    <DialogDescription className="space-y-2">
                        <p>Your account is ready!</p>
                        <p>
                            You'll now be taken to the {props.title} job details.
                        </p>
                        <p>
                            This interview can't be revisited, but you can retake it anytime
                            from the Interviews tab in your dashboard.
                        </p>
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex flex-col sm:flex-row gap-2 w-full">
                    <Button variant="outline" onClick={props.onClose} className="w-full">
                        Stay Here
                    </Button>
                    <Button
                        onClick={() => {
                            props.onConfirm();
                            props.onClose();
                        }}
                        className="w-full bg-blue-600 hover:bg-blue-700"
                    >
                        Proceed to Job Posting
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
